<style lang="scss" scoped>
.news-item {
  position: relative;
  margin-bottom: 30px;
  border-radius: 5px;
  img {
    width: 100%;
    height: auto;
  }
  h2 {
    max-height: 95px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  p {
    max-height: 90px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .description {
    background-color: #f8fdfd;
  }
}
</style>

<template>
    <div class="news-item">
        <a :href="'nieuws/' + data.slug">
            <img v-if="data.image" :src="data.image" :alt="data.slug">
            <div class="description p-25">
                <h2 class="fs-24 ff-ub-b mb-25 text-primary" v-html="title"></h2>
                <p class="fs-20 ff-ub-r text-gray-dark mb-25" v-html="description"></p>
                <a :href="'nieuws/' + data.slug" class="text-primary ff-ub-m fs-16 lh-19">
                    <span>Bekijk meer</span>
                    <i class="ml-3 fal fa-chevron-right"></i>
                </a>
            </div>
        </a>
    </div>
</template>

<script>
export default {
  props: ["data"],

  computed: {
    title() {
      // remove html from description and limit to 120 characters, add ellipsis if longer
      return this.data.title.rendered.replace(/<[^>]+>/g, "").substring(0, 120) + (this.data.title.rendered.length > 120 ? "..." : "");
    },
    description() {
      // remove html from description and limit to 120 characters, add ellipsis if longer
      return this.data.description.replace(/<[^>]+>/g, "").substring(0, 120) + (this.data.description.length > 120 ? "..." : "");
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/news-card.vue